import React from 'react'
import Button from '../shared/Button'
import ExploreMenu from '../components/ExploreMenu'
import Seller from '../components/Seller'
import TopDeals from '../components/TopDeals'
import BottomHero from '../views/BottomHero'
import SlideView from '../components/Slider'
import Footer from '../components/Footer'

const Home = () => {
  return (
    <div>
        
        <SlideView/>
      <div className="container mx-auto flex flex-col gap-3">
        <Button type="solid" data="REORDER" styles="w-[50vw] flex justify-center m-auto my-2"/>
        <ExploreMenu/>
        <Seller/>
        <TopDeals/>
        <BottomHero/>
        <Footer/>
      </div>
    </div>
  )
}

export default Home
